import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../app/modules/auth/auth.service';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css'],
})
export class SideNavComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  @Input() isOpen = false;
  @Output() closeSideNav = new EventEmitter<void>();

  get userInitials(): string {
    const email = this.auth.currentUserEmail();
    if (!email) {
      return 'U';
    }

    const local = email.split('@')[0] ?? '';
    const parts = local.split(/[._-]/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
    }

    return local.slice(0, 2).toUpperCase();
  }

  get userName(): string {
    const email = this.auth.currentUserEmail();
    if (!email) {
      return 'User';
    }

    const local = email.split('@')[0] ?? 'User';
    return local
      .split(/[._-]/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  close() {
    this.closeSideNav.emit();
  }

  onNavLinkClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest('a.nav-link')) {
      this.close();
    }
  }

  logout() {
    this.auth.logout();
    this.close();
    this.router.navigate(['/login']);
  }
}
